
import { Component, Mixins } from 'vue-property-decorator';
import { ProgressbarMixin } from './ProgressbarMixin';

@Component
export default class ProgressBarBrief extends Mixins(ProgressbarMixin) {}
